import { memo, useEffect, useRef } from "react";
import { usePDFCurrentSearchResultElementContext } from "../contexts/PDFCurrentSearchResultElementContext";
import { usePDFViewerSearchContext } from "../contexts/PDFViewerSearch/PDFViewerSearchContext";
/**
 * This component observes the current search result index and scrolls to the current search result element
 */ export const ScrollToCurrentPDFResultObserver = /*#__PURE__*/ memo((param)=>{
    let { listRef, currentPageNumber } = param;
    const { currentResultIndex, getMatchesMapArray } = usePDFViewerSearchContext();
    const { subscribeToCurrentSearchResultElement, getCurrentSearchResultElement } = usePDFCurrentSearchResultElementContext();
    const currentPageNumberRef = useRef(currentPageNumber);
    currentPageNumberRef.current = currentPageNumber;
    useEffect(()=>{
        const subscription = subscribeToCurrentSearchResultElement((element)=>{
            // when page is mounted and element is available, scroll to it
            requestAnimationFrame(()=>{
                var _element_element;
                element === null || element === void 0 ? void 0 : (_element_element = element.element) === null || _element_element === void 0 ? void 0 : _element_element.scrollIntoView({
                    block: "center",
                    inline: "center"
                });
            });
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        subscribeToCurrentSearchResultElement
    ]);
    useEffect(()=>{
        const matchesMapArray = getMatchesMapArray();
        const selectedMatch = matchesMapArray[currentResultIndex];
        var _selectedMatch_pageIndex;
        const pageIndex = (_selectedMatch_pageIndex = selectedMatch === null || selectedMatch === void 0 ? void 0 : selectedMatch.pageIndex) !== null && _selectedMatch_pageIndex !== void 0 ? _selectedMatch_pageIndex : -1;
        const element = getCurrentSearchResultElement();
        if (element) {
            var _element_element;
            element === null || element === void 0 ? void 0 : (_element_element = element.element) === null || _element_element === void 0 ? void 0 : _element_element.scrollIntoView({
                block: "center",
                inline: "center"
            });
        } else if (pageIndex != -1 && pageIndex !== currentPageNumberRef.current - 1) {
            var _listRef_current;
            (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.scrollToIndex(pageIndex);
        }
    }, [
        currentResultIndex,
        getCurrentSearchResultElement,
        getMatchesMapArray,
        listRef
    ]);
    return null;
});
ScrollToCurrentPDFResultObserver.displayName = "ScrollToCurrentPDFResultObserver";
